import React, { ReactNode, useEffect, useState } from 'react'

import { IoIosClose } from 'react-icons/io'

import Button from '../button/Button'

export interface ToastProps {
  show: boolean
  header: ReactNode
  body: ReactNode
  onClose?: () => void
  success?: boolean
  info?: boolean
  warning?: boolean
  position: 'start' | 'center' | 'end' | 'top' | 'middle' | 'bottom'

  actions?: {
    label: string
    onClick: () => void
    ariaLabel?: string
    variant?: string
    className?: string
    success?: boolean
  }[]
}

const alertType = ({ success, info, warning }: { success?: boolean; info?: boolean; warning?: boolean }) => {
  if (success) {
    return 'success'
  }
  if (warning) {
    return 'warning'
  }
  if (info) {
    return 'info'
  }
  return 'info'
}

export default function Toast({ show, header, body, onClose, actions, success, info, warning, position }: ToastProps) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (show) {
      setIsVisible(true)
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300) // Match the Tailwind transition duration
      return () => clearTimeout(timer)
    }
  }, [show])

  const delay = actions && actions.length > 0 ? 10000 : 5000

  useEffect(() => {
    if (show && onClose) {
      const timer = setTimeout(() => {
        onClose()
      }, delay)

      return () => clearTimeout(timer)
    }
  }, [show, onClose, delay])

  if (!isVisible) {
    return null
  }
  return (
    <div
      className={`toast toast-${position} bg-base-100 transition-all ease-in-out ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
    >
      <div
        className={`alert alert-${alertType({ success, info, warning })} flex flex-col items-start justify-items-center gap-2 p-0 rounded-xs`}
      >
        <div className="flex justify-between items-center pt-2 px-4 w-full">
          <h3 className="">{header}</h3>
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer hover:text-neutral p-0 m-0"
            aria-label="Close"
          >
            <IoIosClose className="p-0 h-8 w-8" />
          </button>
        </div>
        <div className="bg-base-100 p-4">
          {body}
          <div className="mt-2 flex flex-row-reverse items-center justify-start">
            {Array.isArray(actions) &&
              actions.map((action) => (
                <Button
                  key={action.label}
                  handleClick={action.onClick}
                  ariaLabel={action.ariaLabel}
                  size="sm"
                  className={`btn-${alertType({ success, info, warning })}`}
                >
                  {action.label}
                </Button>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

//  {
//    onClose && (
//      <div className="mt-2 flex flex-row-reverse items-center justify-start">
//        <Button
//          children={'Close'}
//          handleClick={() => onClose}
//          size="sm"
//          className={`btn-${alertType({ success, info, warning })}`}
//        />
//        {/* <button className="bg-red-400" onClick={onClose}> */}
//        {/* Close
//               </button> */}
//      </div>
//    )
//  }
